/*
  getUserPrefersDarkMode.js
*/

/**
 * Returns true if the user prefers a dark theme based on their device settings.
 */
export default function getUserPrefersDarkMode() {

  if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  }

  return false;

}
